import {
  createFileRoute,
  notFound,
  Outlet,
  useMatch,
} from "@tanstack/react-router";
import { FeatureLink } from "@softmax/web-features/navigation";
import { buildHref } from "@softmax/web-addresses";
import { GameLibrary, LeagueExplorer } from "@softmax/ide/frontend";
import { defaultLeagueId, leagueIdSchema } from "@softmax/ide/league-catalog";

export const Route = createFileRoute("/_workspace/ide-next")({
  validateSearch: (search: Record<string, unknown>) => ({
    league: search.league,
  }),
  beforeLoad: ({ search }) => {
    if (search.league === undefined) return { leagueId: undefined };

    const league = leagueIdSchema.safeParse(search.league);

    if (!league.success) throw notFound({ routeId: "/_workspace/ide-next" });

    return { leagueId: league.data };
  },
  component: IdeWorkspace,
  notFoundComponent: () => (
    <main className="shell">
      <h1>Workspace not found</h1>
      <FeatureLink href={buildHref({ name: "ideNext" })}>
        Choose a game
      </FeatureLink>
    </main>
  ),
});

function IdeWorkspace() {
  const { leagueId } = Route.useRouteContext();
  const session = useMatch({
    from: "/_workspace/ide-next/s/$sessionId",
    shouldThrow: false,
  });
  const resolvedLeagueId = leagueId ?? defaultLeagueId;

  return (
    <>
      {session || leagueId ? (
        <LeagueExplorer key={resolvedLeagueId} leagueId={resolvedLeagueId} />
      ) : (
        <GameLibrary />
      )}
      <Outlet />
    </>
  );
}
